
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/device/${viewName}`)
            if (!modules.default.options.metaInfo) {
                modules.default.options.metaInfo = { title }
            }
            resolve(modules)
        }, reject, 'project')
    }
}

let routes = [
    {
        name: 'deviceList',
        path: '/ems/deviceList',
        meta: {
            title: '设备列表'
        }
    },
    {
        name: 'deviceDetail',
        path: '/ems/deviceDetail',
        meta: {
            title: '设备详情'
        }
    },
    {
        name: 'itemsDetail',
        path: '/device/itemsDetail',
        meta: {
            title: '设备详情'
        }
    },
    {
        name: 'deviceEditor',
        path: '/ems/deviceEditor',
        meta: {
            title: '设备编辑'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/device.js